import Api from "../axios"

export const getLeaveRequestsList= async (employeeId)=>{
    return await Api.get(`/leave_request_list?employee_id=${employeeId || ""}`);
}